import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const fundFamilyConfigurationFundStructureRoutes: RouteObject = {
  id: "fundFamilyConfigurationFundStructure",
  path: "structure",
  children: [
    {
      id: "fundFamilyFundStructureSetupIndex",
      handle: {
        showSidebar: true,
      },
      lazy: async () => {
        const { FundFamilyConfigurationFundStructurePage } = await import(
          "features/fund-family/configuration/fund-structure/FundFamilyConfigurationFundStructurePage"
        );
        return { Component: FundFamilyConfigurationFundStructurePage };
      },
      children: [
        {
          id: "allocations",
          path: "",
          lazy: async () => {
            const { AllocationRuleGraphsTableContent } = await import(
              "features/fund-family/configuration/fund-structure/AllocationRuleGraphsTableContent"
            );
            return { Component: AllocationRuleGraphsTableContent };
          },
          handle: {
            title: i18n.t("common:fundStructure"),
          },
        },
      ],
    },
    {
      id: "fundFamilyConfigurationAllocationRuleGraphCreate",
      path: "rule/create",
      lazy: async () => {
        const { AllocationRuleGraphCreatePageWrapper } = await import(
          "features/fund-family/configuration/fund-structure/create-page/AllocationRuleGraphCreatePageWrapper"
        );
        return { Component: AllocationRuleGraphCreatePageWrapper };
      },
    },
    {
      id: "fundFamilyConfigurationAllocationRuleGraphAndUse",
      path: "rule/:allocationRuleGraphId/use/:allocationRuleGraphUseId",
      lazy: async () => {
        const { AllocationRuleGraphPage } = await import(
          "features/fund-family/configuration/fund-structure/AllocationRuleGraphPage"
        );
        return { Component: AllocationRuleGraphPage };
      },
      children: [
        {
          id: "rule-graph-and-use-details",
          path: "rule-graph-use-details",
          lazy: async () => {
            const { AllocationRuleGraphTabDetails } = await import(
              "features/fund-family/configuration/fund-structure/AllocationRuleGraphTabDetails"
            );
            return { Component: AllocationRuleGraphTabDetails };
          },
          handle: {
            title: i18n.t("allocation:ruleGraphDetails:title"),
          },
        },
        {
          id: "basis",
          path: "basis",
          lazy: async () => {
            const { AllocationRuleGraphTabBasis } = await import(
              "features/fund-family/configuration/fund-structure/AllocationRuleGraphTabBasis"
            );
            return { Component: AllocationRuleGraphTabBasis };
          },
          handle: {
            title: i18n.t("allocation:ruleGraphBasis:title"),
          },
        },
      ],
    },
    {
      id: "fundFamilyConfigurationAllocationRuleGraph",
      path: "rule/:allocationRuleGraphId/",
      lazy: async () => {
        const { AllocationRuleGraphPage } = await import(
          "features/fund-family/configuration/fund-structure/AllocationRuleGraphPage"
        );
        return { Component: AllocationRuleGraphPage };
      },
      children: [
        {
          id: "rule-graph-details",
          path: "rule-graph-details",
          lazy: async () => {
            const { AllocationRuleGraphTabDetails } = await import(
              "features/fund-family/configuration/fund-structure/AllocationRuleGraphTabDetails"
            );
            return { Component: AllocationRuleGraphTabDetails };
          },
          handle: {
            title: i18n.t("allocation:ruleGraphDetails:title"),
          },
        },
        {
          id: "rule-graph-basis",
          path: "rule-graph-basis",
          lazy: async () => {
            const { AllocationRuleGraphTabBasis } = await import(
              "features/fund-family/configuration/fund-structure/AllocationRuleGraphTabBasis"
            );
            return { Component: AllocationRuleGraphTabBasis };
          },
          handle: {
            title: i18n.t("allocation:ruleGraphBasis:title"),
          },
        },
      ],
    },
  ],
};
